import { TemplateGQL } from '@schema';
import { QueryData } from '@shared/apollo/query-actions';
import { NamingConfig } from '@shared/naming/naming-config';

export type Template = Omit<QueryData<TemplateGQL, ['integrateTemplates']>[number], '__typename'>;

export const TemplateNaming = NamingConfig<Template>({
  key: 'Template',
  modelName: { '=1': $localize`Template`, other: $localize`Templates` },
  fieldNames: {
    id: $localize`ID`,
    customerId: $localize`Customer`,
    name: $localize`Name`,
    body: $localize`Body`,
    internalEventId: $localize`Event Type`,
    createdUtc: $localize`Created`,
    createdBy: $localize`Created By`,
    updatedUtc: $localize`Updated`,
    updatedBy: $localize`Updated By`,
    deletedUtc: $localize`Deleted`,
    deletedBy: $localize`Deleted By`,
  },
});
